export default "__VITE_ASSET__c7dbf322__"